// endpointMap.js

const endpointMap = {
  // Pinecone migrations
  pinecone_milvus: "/migrate/pinecone-to-milvus",
  pinecone_qdrant: "/migrate/pinecone-to-qdrant",
  pinecone_chroma: "/migrate/pinecone-to-chroma",
  pinecone_weaviate: "/migrate/pinecone-to-weaviate",
  pinecone_mongo: "/migrate/pinecone-to-mongo",
  pinecone_pgvector: "/migrate/pinecone-to-pgvector",

  // Milvus migrations
  milvus_milvus: "/migrate/milvus-to-milvus",
  milvus_qdrant: "/migrate/milvus-to-qdrant",
  milvus_chroma: "/migrate/milvus-to-chroma",
  milvus_weaviate: "/migrate/milvus-to-weaviate",
  milvus_mongo: "/migrate/milvus-to-mongo",
  milvus_pgvector: "/migrate/milvus-to-pgvector",

  // Qdrant migrations
  qdrant_milvus: "/migrate/qdrant-to-milvus",
  qdrant_chroma: "/migrate/qdrant-to-chroma",
  qdrant_qdrant: "/migrate/qdrant-to-qdrant",
  qdrant_weaviate: "/migrate/qdrant-to-weaviate",
  qdrant_mongo: "/migrate/qdrant-to-mongo",
  qdrant_pgvector: "/migrate/qdrant-to-pgvector",

  // Chroma migrations
  chroma_milvus: "/migrate/chroma-to-milvus",
  chroma_qdrant: "/migrate/chroma-to-qdrant",
  chroma_chroma: "/migrate/chroma-to-chroma",
  chroma_weaviate: "/migrate/chroma-to-weaviate",
  chroma_mongo: "/migrate/chroma-to-mongo",
  chroma_pgvector: "/migrate/chroma-to-pgvector",

  // Weaviate migrations
  weaviate_milvus: "/migrate/weaviate-to-milvus",
  weaviate_qdrant: "/migrate/weaviate-to-qdrant",
  weaviate_chroma: "/migrate/weaviate-to-chroma",
  weaviate_weaviate: "/migrate/weaviate-to-weaviate",
  weaviate_mongo: "/migrate/weaviate-to-mongo",
  weaviate_pgvector: "/migrate/weaviate-to-pgvector",

  // MongoDB migrations
  mongo_milvus: "/migrate/mongo-to-milvus",
  mongo_qdrant: "/migrate/mongo-to-qdrant",
  mongo_chroma: "/migrate/mongo-to-chroma",
  mongo_weaviate: "/migrate/mongo-to-weaviate",
  mongo_mongo: "/migrate/mongo-to-mongo",
  mongo_pgvector: "/migrate/mongo-to-pgvector",

  // PGVector migrations (new)
  pgvector_milvus: "/migrate/pgvector-to-milvus",
  pgvector_qdrant: "/migrate/pgvector-to-qdrant",
  pgvector_chroma: "/migrate/pgvector-to-chroma",
  pgvector_weaviate: "/migrate/pgvector-to-weaviate",
  pgvector_mongo: "/migrate/pgvector-to-mongo",
  pgvector_pgvector: "/migrate/pgvector-to-pgvector",
};

export default endpointMap;